import { useDispatch } from "react-redux";
import { setSendData } from "../../../Store/Slice/scheduleSlice";
import showToast from "../../Hooks/toast";
import {
  isValidGoogleAddressLocation,
  parseGoogleAddressLocation,
  parseGoogleStreetAddress,
} from "../../Hooks/parseGoogleAddress";

const useSetAddress = () => {
  const dispatch = useDispatch();

  const set = (address) => {
    if (!address?.info) return;

    const location = parseGoogleAddressLocation(address.info);

    if (!address?.lat || !address?.lon || !isValidGoogleAddressLocation(location)) {
      showToast("Invalid Address", "error");
      return;
    }

    const streetAddress = parseGoogleStreetAddress(address.info);

    dispatch(
      setSendData({
        job_address: streetAddress || address?.address,
        location,
        lat: address.lat,
        lon: address.lon,
      })
    );
  };

  return {
    set,
  };
};

export default useSetAddress;
